import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { getOtherProperties } from "../common/Utils";
import { KeyBoardProps } from "./PropsType";

export default function KeyBoard(props: KeyBoardProps) {
  const {
    action,
    className,
    prefixCls = "bm-KeyBoard",
    count = 5,
    title = "输入数字密码",
    ...other
  } = props;
  const styleClass = classNames(prefixCls, className);
  const otherProps = getOtherProperties(other, [
    "children",
    "count",
    "onClose",
    "onFinish",
    "random",
  ]);
  const [numbers, setNumbers] = useState<Array<number>>([]);

  const [password, setPassword] = useState<string>("");

  const handleClick = (num: number) => {
    if (count <= password.length) {
      return;
    }
    const currentPassword = password! + num;
    setPassword(password! + num);
    if (props.onFinish) {
      (props.onFinish as (event: any) => void)(currentPassword);
    }
  };

  const handleClose = () => {
    if (props.onClose) {
      (props.onClose as () => void)();
    }
  };

  const handleDelete = () => {
    setPassword(password.slice(0, password.length - 1));
  };

  const getPasswordInput = () => {
    const children: any = [];
    for (let i = 0; i < count!; i++) {
      children.push(
        <li key={`pwd-${i}`}>
          <i
            style={{
              display: (password as string).length > i ? "block" : "none",
            }}
          />
        </li>
      );
    }
    return children;
  };

  const getNumbersSpan = () => {
    const children: any = [];
    numbers.forEach((num: number) => {
      children.push(
        <span key={`numbers-${num}`} onClick={handleClick.bind(null, num)}>
          {num}
        </span>
      );
    });
    children.push(
      <span key={`pwd-cancel`} onClick={handleClose}>
        取消
      </span>
    );
    children.push(
      <span key={`pwd-zero`} onClick={handleClick.bind(null, 0)}>
        0
      </span>
    );
    children.push(
      <span key={`pwd-delete`} className={`${prefixCls}-delete`} onClick={handleDelete}>
        <svg
          className="icon bm-icon-backspace"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="868"
          width="64"
          height="64"
        >
          <path
            d="M790 192H460c-93.4 0-146.4 69.4-204 127s-144.2 149.4-144.2 149.4C102 479.6 96 494 96 510.2c0 16 6 30.6 15.8 42 0 0 68.6 75.2 144.2 151 75.6 75.6 113.4 129 204 129h330c77 0 138-65 138-142V330c0-77-61-138-138-138z m-35.4 425.4c12.4 12.4 12.4 32.8 0 45.2-12.4 12.4-32.8 12.4-45.2 0L604 557.2l-105.4 105.4c-12.4 12.4-32.6 12.8-45.2 0-12.8-12.8-13.4-31.8 0-45.2l105.4-105.4-105.4-105.4c-12-12-14.2-31.2 0-45.2 14.2-14.2 32.8-12.4 45.2 0l105.4 105.4 105.4-105.4c12.4-12.4 32.8-12.4 45.2 0 12.4 12.4 12.4 32.8 0 45.2L649.2 512l105.4 105.4z"
            p-id="869"
          ></path>
        </svg>
      </span>
    );
    return children;
  };

  useEffect(() => {
    let numbers: Array<number> = [];
    for (let i = 0; i < 9; i++) {
      numbers.push(i + 1);
    }
    if (props.random) {
      numbers = numbers.sort(() => {
        return Math.random() > 0.5 ? 1 : -1;
      });
    }
    setNumbers(numbers);
  }, [props.random]);

  return (
    <div className={styleClass} {...otherProps}>
      <div className={`${prefixCls}-header`}>
        <strong>{title}</strong>
      </div>
      <div className={`${prefixCls}-password`}>{getPasswordInput()}</div>
      <div className={`${prefixCls}-toolbar`}>{action}</div>
      <div className={`${prefixCls}-content`}>
        <div className={`${prefixCls}-numbers`}>{getNumbersSpan()}</div>
      </div>
    </div>
  );
}
